import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import * as XLSX from 'xlsx';
import { MatStepper } from '@angular/material/stepper';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { XlMapperService } from 'src/app/services/xl-mapper.service';
import { Constant } from 'src/app/constant/constant';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';

@Component({
  selector: 'calsoft-custom-excel-mapper',
  templateUrl: './custom-excel-mapper.component.html',
  styleUrls: ['./custom-excel-mapper.component.scss']
})
export class CustomExcelMapperComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  filelist: any;
  arrayBuffer: any;
  file: any;

  text: string;

  selectedFile: File | null = null;
  fileError: string | null = null;

  readonly allowedTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-excel',                                           // .xls
    'text/csv',                                                           // .csv
  ];
  readonly allowedExtensions = ['.xlsx', '.xls', '.csv'];

  mapperKeys: string[] = [];

  @Input() title: string;

  @Input() type: any;

  @Input() serviceUrl: any;

  @Input() serviceName: any;

  @Input() route: any;

  @Input() primaryTitle = 'Xl Mapper';

  @Input() mapper: any = [];

  secondFormGroup: UntypedFormGroup;

  isLinear = false;

  orientation: string;

  firstFormGroup: UntypedFormGroup;

  constructor(
    private dialog: MatDialog,
    public loc: Location,
    private _formBuilder: UntypedFormBuilder,
    private leadSourceService: LeadSourceService,
    private router: Router,
    private snackBar: MatSnackBar,
    private xlMapperService: XlMapperService,
    private googleCalendarServiceAccountService: GoogleCalendarServiceAccountService,
  ) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  textNew: any;


  ngOnInit() {

    if (window.innerWidth > 768) {
      this.orientation = "horizontal"
    } else {
      this.orientation = "vertical"
    }

    this.text = 'Submit';

    this.textNew = 'Upload';

    this.initForm();

    this.getAllAttributeList();

    this.attributeYFilter();

    this.secondFormGroup = this._formBuilder.group({
      status: ['', Validators.required]
    });
  }


  addfile(event: any) {
    this.file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);

    fileReader.onload = () => {
      this.arrayBuffer = fileReader.result;
      let data = new Uint8Array(this.arrayBuffer);
      let arr = [];
      for (let i = 0; i !== data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      let bstr = arr.join("");

      let workbook = XLSX.read(bstr, { type: "binary" });
      let first_sheet_name = workbook.SheetNames[0];
      let worksheet = workbook.Sheets[first_sheet_name];
      this.filelist = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      if (this.filelist.length > 0) {
        this.mapperKeys = Object.keys(this.filelist[0]);
      }
      console.log("Extracted Titles:", this.mapperKeys);
    }
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    const hasValidExt = this.allowedExtensions.some(ext => fileName.endsWith(ext));
    const hasValidType = this.allowedTypes.includes(file.type) || file.type === '';

    if (!hasValidExt) {
      this.fileError = `Invalid file type "${file.name}". Only Excel (.xlsx, .xls) or CSV (.csv) files are allowed.`;
      this.selectedFile = null;
      event.target.value = ''; // reset the input
      return;
    }

    this.fileError = null;
    this.selectedFile = file;
  }

  fileUpload = false;

  uploadFile(): void {
    if (!this.selectedFile) {
      alert("Please select a file first.");
      return;
    }

    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.selectedFile);

    fileReader.onload = () => {
      this.arrayBuffer = fileReader.result;
      const data = new Uint8Array(this.arrayBuffer);
      const arr = [];

      for (let i = 0; i !== data.length; ++i) {
        arr[i] = String.fromCharCode(data[i]);
      }

      const bstr = arr.join("");
      const workbook = XLSX.read(bstr, { type: "binary", cellDates: true }); // ✅ ensure cellDates = true
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Get raw data as 2D array
      const rawData: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const headers = rawData[0] || [];
      const rows = rawData.slice(1);

      const filelist = rows.map(row => {
        const rowData: any = {};
        headers.forEach((header, index) => {
          const cellValue = row[index];

          console.log(header);
          console.log(cellValue);

          // ✅ Convert Excel date object to formatted string

          if (cellValue instanceof Date) {
            // It's a full date (or date+time)
            if (header.includes('time') ) {
              // Extract only HH:mm from Date object
              const hours = cellValue.getHours().toString().padStart(2, '0');
              const minutes = cellValue.getMinutes().toString().padStart(2, '0');
              rowData[header] = `${hours}:${minutes}`;
            } else {
              rowData[header] = this.formatDate(cellValue); // Your existing date formatter
            }
          } else if (typeof cellValue === 'string' && /^\d{2}:\d{2}$/.test(cellValue)) {
            // Matches time format like "12:02"
            rowData[header] = cellValue + ':00'; // Optionally add seconds
          } else {
            rowData[header] = cellValue || '';
          }
        });
        return rowData;
      });

      this.filelist = filelist;
      this.mapperKeys = headers.filter(h => !!h && typeof h === 'string');
      this.populateSourceMapperFromKeys(this.mapperKeys);

      this.fileUpload = true;
      this.secondFormGroup.get('status')?.setValue('uploaded');

      console.log("Extracted Headers:", this.mapperKeys);
    };
  }

  // ✅ Helper function
  formatDate(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // month 0-based
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  back() {
    this.loc.back();
  }


  goToStep3(stepper: MatStepper) {

    stepper.next();

  }


  initForm() {
    this.firstFormGroup = this._formBuilder.group({
      id: [0],
      name: [''],
      sourceMapper: this._formBuilder.array([
        this.initSourceMapper()
      ]),

    });
  }

  initSourceMapper(): UntypedFormGroup {
    return this._formBuilder.group({
      sourceMapperId: [''],
      sourceId: [''],
      formFields: [''],
      fieldMapper: [''],
      type: [0],
      isActive: [0],
    });
  }

  addOption() {

    (<UntypedFormArray>this.firstFormGroup.get('sourceMapper')).push(
      this.initSourceMapper()
    );

  }


  populateSourceMapperFromKeys(keys: string[]) {
    const control = <UntypedFormArray>this.firstFormGroup.get('sourceMapper');
    control.clear();

    keys.forEach(key => {
      control.push(this._formBuilder.group({
        sourceMapperId: [''],
        sourceId: [''],
        formFields: [''],
        fieldMapper: [key],
        type: [0],
        isActive: [1],
      }));
    });
  }

  removeOption(i) {
    (<UntypedFormArray>this.firstFormGroup.get('sourceMapper')).removeAt(i);
  }


  //attribute
  attributeList: any = [];
  attributeTypeList: any = [];
  filteredAttributeTypeList: any = [];
  attributeControl: UntypedFormControl = new UntypedFormControl();
  attributeFilterControl: UntypedFormControl = new UntypedFormControl();

  protected _onDestroy = new Subject<void>();

  getAllAttributeList() {

    console.log("type", this.type);


    this.leadSourceService.getDropDown(this.type).subscribe(
      data => {
        this.attributeList = data;
        this.attributeTypeList = data;
        this.filteredAttributeTypeList = this.attributeTypeList;

      }
    )

    this.attributeYFilter();

  }


  getAllAttribute() {
    this.filteredAttributeTypeList = this.attributeTypeList;
  }

  attributeYFilter() {
    this.attributeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.attributeFilter();
      });
  }

  protected attributeFilter() {
    if (!this.attributeList) {
      return;
    }
    // get the search keyword
    let search = this.attributeFilterControl.value;
    if (!search) {
      this.filteredAttributeTypeList = this.attributeTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredAttributeTypeList = this.attributeTypeList.filter(Attribute => Attribute['frontendLabel'].toLowerCase().indexOf(search) > -1)
  }

  goToStep(stepper: MatStepper) {

    stepper.next();

    this.submit();

  }

  finalUpload(stepper: MatStepper) {

    this.textNew = "Processing"

    console.log("this.mappedPreview", this.mappedPreview);


    this[this.serviceUrl][this.serviceName](this.mappedPreview).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.textNew = "Upload";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          stepper.next();

        }
        else {
          this.textNew = "Upload";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => { this.textNew = "Upload" });

  }

  displayedFormFields: string[] = [];

  mappedPreview: any[] = [];

  submit(): void {
    if (this.firstFormGroup.valid) {
      this.text = 'Processing';

      setTimeout(() => {
        const formData = this.firstFormGroup.value;

        this.mappedPreview = this.filelist.map((row) => {
          const mappedRow: any = {};
          formData.sourceMapper.forEach((map) => {
            if (map.fieldMapper && map.formFields) {
              mappedRow[map.formFields] = row[map.fieldMapper] || '';
            }
          });
          return mappedRow;
        }).filter(row =>
          Object.values(row).some(value => value !== '' && value != null)
        );

        // Display only selected form field columns
        this.displayedFormFields = formData.sourceMapper
          .filter(map => map.formFields)
          .map(map => map.formFields);

        this.text = 'Submit';
      }, 500);

    } else {
      this.firstFormGroup.markAllAsTouched();
    }
  }


  deleteRow(row: any): void {
    const index = this.mappedPreview.indexOf(row);
    if (index !== -1) {
      this.mappedPreview.splice(index, 1);
      this.mappedPreview = [...this.mappedPreview];
    }
  }

  goToProductPage() {
    this.router.navigate([this.route])
  }

  isFieldAlreadySelected(attributeCode: string, currentIndex: number): boolean {
    const sourceMapper = this.firstFormGroup.get('sourceMapper').value;


    return sourceMapper.some((group, index) => {
      return index !== currentIndex && group.formFields === attributeCode;
    });
  }

  listOfAttributeSelected: any = [];

  selectedData(event, eavAttribute) {

    if (event.isUserInput != false) {
      if (event.source._selected) {
        this.listOfAttributeSelected.push(eavAttribute.attributeId);

      } else {
        let index = this.listOfAttributeSelected.findIndex(x => x == eavAttribute.attributeId)
        this.listOfAttributeSelected.splice(index, 1);

      }
    }

  }






  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}

